import EfSectionMedia from '@elem/ui/ef-section-media';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('power_kits_48v_system');
    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-xx" />
            <EfSectionMedia
                pc="https://websiteoss.ecoflow.com/upload/image/1744600473303/pc_Compact.png"
                pad="https://websiteoss.ecoflow.com/upload/image/1744600473303/pc_Compact.png"
                h5="https://websiteoss.ecoflow.com/upload/image/1744600473115/m_Compact.png"
                desc={t('O_desc')}
                title={t('O_title')}
            />
            <EfSpec className="spec-x" />
        </div>
    );
}
